import { useFirestoreGeneralOrderBy } from '../../firebase/useFirestore';

const SubTargetgroupsEvents = ({ fieldId, targetgroupId, selected = [], onToggle, disabled = false }) => {
  const subTargetgroups = useFirestoreGeneralOrderBy(
    'SubTargetgroups',
    'TargetgroupID',
    targetgroupId || "",
    'Position',
    'asc'
  );

  const handleChange = (e) => {
    const subId = e.target.value;
    const checked = e.target.checked;
    onToggle(fieldId, targetgroupId, subId, checked);
  };

  return (
    <div id='events-subtargetgroups-container' style={{ marginLeft: 24, opacity: disabled ? 0.5 : 1 }}>
      {subTargetgroups && subTargetgroups.map(sub => (
        <div key={sub.ID} id='add-event-targetgroup-item-container'>
          <input
            type="checkbox"
            value={sub.ID}
            onChange={handleChange}
            checked={selected.includes(sub.ID)}
            disabled={disabled}
          />
          <label>{sub.Title}</label>
        </div>
      ))}
    </div>
  );
};

export default SubTargetgroupsEvents;
